import { useEffect } from 'react';
import { isRouteErrorResponse } from 'react-router-dom';
import { LayoutProviders } from 'src/common/components/layout/layout';
import { CriticalError } from 'src/features/error-pages/critical-error';
export const AppErrorDisplay = ({
  error,
  nativeLink = false
}: {
  error: unknown;
  nativeLink?: boolean;
}) => {
  useEffect(() => {
    const loader = window.APP_LOADER_ELEMENT;
    if (loader) {
      // Clear any pending show timeout
      if (window.APP_LOADER_TIMEOUT) {
        clearTimeout(window.APP_LOADER_TIMEOUT);
        window.APP_LOADER_TIMEOUT = undefined;
      }
      loader.style.opacity = '0';
    }
  }, []);
  const errorString = (() => {
    if (isRouteErrorResponse(error)) {
      return `${error.status} ${error.statusText}`;
    }
    if (error instanceof Error) {
      return error.toString();
    }
    return undefined;
  })();
  return <LayoutProviders data-sentry-element="LayoutProviders" data-sentry-component="AppErrorDisplay" data-sentry-source-file="app-error-display.tsx">
      <CriticalError message={errorString} nativeLink={nativeLink} data-sentry-element="CriticalError" data-sentry-source-file="app-error-display.tsx" />
    </LayoutProviders>;
};